module.exports = __webpack_public_path__ + "static/img/egg_titlezh-tw.dffc369.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/egg_titlezh-tw.png
// module id = /nJL
// module chunks = 1